var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"app-aside flex-column",staticStyle:{"background":"#fff"},attrs:{"id":"kt_app_aside"}},[_c('div',{staticClass:"d-flex flex-column align-items-center hover-scroll-y mt-lg-n3 py-5 py-lg-0 gap-4",attrs:{"id":"kt_app_aside_wrapper"}})])
}]

export { render, staticRenderFns }